import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-b mb-4 pb-4 flex items-center" }
const _hoisted_2 = { class: "text-2xl mr-4 inline-block" }



export default /*#__PURE__*/_defineComponent({
  __name: 'ListHeader',
  props: {
  label: {
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.label), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})